export default __webpack_public_path__ + "static/media/cra-output.cc1f2fd2.PNG";